<template>
  <div id="privacy" class="overlay agreement">
    <div class="inner_static">
      <div class="inner_box">
        <a class="btn_close" @click="btnCloseClick()"></a>
        <h5 class="tit_agreement">プライバシーポリシー</h5>
        <dl class="lst_agreement">
          <dt>・プライバシーポリシー</dt>
          <dd>
            プライバシーポリシー
          </dd>
          <dd>
            プライバシーポリシー
          </dd>
          <dd>
            プライバシーポリシー
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    btnCloseClick: function (event) {
      if (event) {
        event.preventDefault()
      }
      var scrollpos = 0
      var elements = document.getElementsByClassName('agreement')
      // 配列に変換
      var array = Array.prototype.slice.call(elements)
      var target = array.find(p => p.classList.contains('open'))
      var bodyElements = document.getElementsByTagName('body')
      if (target) {
        target.classList.remove('open')
        bodyElements[0].classList.remove('fixed')
        bodyElements[0].style.top = 0
        window.scrollTo(0, scrollpos)
      } else {
        target.classList.add('open')
        scrollpos = window.scrollTop
        bodyElements[0].classList.add('fixed')
        bodyElements[0].style.top = -scrollpos
      }
    }
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/common/PrivacyPolicy.vue